import * as React from "react"

import { usePublicBoundlessConfigRetrieveSuspense } from "@boundless/bl-api-client/public/services"
import { Link } from "@tanstack/react-router"
import { ChevronDown } from "lucide-react"

import { AvatarBadge } from "@/components/layout/AvatarBadge"
import { Button } from "@/components/ui/button"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"

import type { User } from "@boundless/bl-api-client/common/models"

export function UserBadge({
  onLogout,
  user,
}: {
  user: User
  onLogout: () => void
}) {
  const [open, setOpen] = React.useState(false)
  const { data: boundlessConfig } = usePublicBoundlessConfigRetrieveSuspense()

  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          className="flex h-12 items-center gap-3 p-0 hover:bg-transparent focus:ring-0 focus-visible:ring-0 active:bg-transparent"
        >
          <AvatarBadge user={user} />
          <div className="flex h-12 flex-col justify-center">
            <span className="text-sm leading-none font-medium">
              {user.firstName} {user.lastName}
            </span>
            <span className="text-muted-foreground mt-1 text-xs leading-none">
              {user.email}
            </span>
          </div>
          <ChevronDown
            className={`h-5 w-5 text-gray-400 transition-transform ${open ? "rotate-180" : ""}`}
            aria-label="Chevron Down"
            role="img"
          />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem role="menuitem" asChild>
          <Link className="cursor-pointer" to={"/settings/my-account"}>
            My Account
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem role="menuitem" asChild>
          <Link
            className="cursor-pointer"
            to={boundlessConfig.bookACallUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            Book a Call
          </Link>
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem
          role="menuitem"
          className="cursor-pointer"
          onClick={onLogout}
        >
          Log out
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
